var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories-page"},[_c('BreadCrumbsVue'),_c('DetailCategoriesVue',{attrs:{"categorySlug":_vm.categorySlug}}),_c('LastCategoryWorksVue',{attrs:{"categorySlug":_vm.categorySlug}}),_c('FeaturesVue'),_c('InfoBlockVue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }